export default {
    settings: ['admin'],
    users: ['admin'],
}
